<template>
  <Layout>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div>
              <div class="card top-draft">
                <div
                  class="col-lg-12 list-header mg-top-1 pad-header-bg clearfix"
                >
                  <div
                    style="line-height: 28px; float: left; font-size: 15px; font-weight: 500"
                  >
                    <span style="margin-right: 20px;"
                      >红包总点数：{{ redPacketData.totalAmount }}</span
                    >
                    <span style="margin-right: 20px;"
                      >已发放点数：{{ redPacketData.grantAmount }}</span
                    >
                    <span style="margin-right: 20px;"
                      >待发放点数：{{ redPacketData.leftAmount }}</span
                    >
                  </div>
                  <div class="header-item-fix">
                    <b-form-input
                      size="sm"
                      type="text"
                      v-model="pageParams.keyword"
                      placeholder="请输入搜索内容"
                    ></b-form-input>
                    <b-button size="sm" variant="primary" @click="search()">
                      <i
                        class="bx bx-search-alt-2 font-size-16 align-middle"
                      ></i>
                      搜索
                    </b-button>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="resetParams()"
                    >
                      <i class="bx bx-revision font-size-16 align-middle"></i>
                      重置
                    </b-button>
                  </div>
                  <div class="header-item-fix">
                    <date-picker
                      class="list-date-picker"
                      v-model="daterange"
                      type="date"
                      placeholder="开始时间 - 结束时间"
                      range
                      lang="en"
                      confirm
                    ></date-picker>
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="table-responsive">
                    <table
                      class="table project-list-table table-nowrap table-centered table-borderless align-middle table-hover"
                    >
                      <thead>
                        <tr>
                          <!-- <th scope="col" style="width: 70px;">
                            <b-form-checkbox
                              @change="checkedAll"
                              v-model="indeterminate"
                              checked
                              plain
                              ></b-form-checkbox>
                          </th> -->
                          <th scope="col" style="width: 70px;">ID</th>
                          <th scope="col">手机号</th>
                          <th scope="col">昵称</th>
                          <th scope="col">金额</th>
                          <th scope="col">付款单号</th>
                          <th scope="col">发放日期</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in items" :key="item.id">
                          <!-- <td>
                            <b-form-checkbox
                              v-model="choiceListIds"
                              :value="item.id"
                              checked
                              plain
                              ></b-form-checkbox>
                          </td> -->
                          <td>{{ item.id }}</td>
                          <td>{{ item.user.phone }}</td>
                          <td>{{ item.user.nickname }}</td>
                          <td>{{ item.amount }}元</td>
                          <td>{{ item.paymentNo || "--" }}</td>
                          <td>{{ item.updatedAt || "--" }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <!-- :isBatch 如果有批量操作就传这个参数 没有就不传
                  batchs 批量操作的列表
                  pageCallback 分页组件的回调方法 -->
                  <pagination
                    ref="page"
                    @pageCallback="pageCallback"
                  ></pagination>
                </div>
              </div>
              <app-list-loading ref="loading"></app-list-loading>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import Vue from "vue";
import Swal from "sweetalert2";
import pagination from "@/components/pagination/pagination.vue"; //置顶稿件
import content from "../../../server/api/videoPublish";
import DatePicker from "vue2-datepicker";

/**
 * Contacts-list component
 */
export default {
  components: {
    Layout,
    pagination,
    DatePicker,
  },

  data() {
    return {
      daterange: "", // 开始时间到结束时间
      choiceListIds: [], //当前所选择的id
      allListIds: [],
      indeterminate: false, //全选
      redPacketData: {},
      pageParams: {
        page: 1,
        pageSize: 30,
        keyword: "",
      },
      index_id: "",
      items: [],
      batchs: [
        //批量操作有哪些操作
        { text: "批量操作", value: "0" },
        { text: "删除", value: "1" },
        { text: "入库", value: "2" },
      ],
    };
  },

  watch: {
    choiceListIds: function() {
      if (
        this.choiceListIds.length == this.allListIds.length &&
        this.choiceListIds.length > 0
      ) {
        this.indeterminate = true;
      } else {
        this.indeterminate = false;
      }
    },
  },

  mounted() {
    if (this.$route.query.redPacketData) {
      this.redPacketData = JSON.parse(this.$route.query.redPacketData);
    }
    if (this.$route.query.redPacketId) {
      this.index_id = this.$route.query.redPacketId;
      this.getList();
    }
  },

  created() {},

  methods: {
    //获取列表数据
    getList() {
      this.items = [];
      let params = this.utils.getQuery(this.pageParams);
      params.redPacketId = this.index_id;
      if (this.daterange) {
        params.start = this.daterange[0].format("yyyy-MM-dd");
        params.end = this.daterange[1].format("yyyy-MM-dd");
      }
      this.$refs.loading.show();
      content.redPacketHistory(params).then((resp) => {
        if (resp.data) {
          if (this.$refs.loading) {
            this.$refs.loading.hide(resp.data.items);
          }
          if (resp.data.items) {
            let ids = [];
            resp.data.items.map((item) => {
              ids.push(item.id);
              item.amount = parseFloat(item.amount / 100).toFixed(2);
            });
            this.choiceListIds = [];
            this.allListIds = ids; //当前列表全部id
            this.items = resp.data.items;
            let pages = {
              page: resp.data.page, //第几页
              pageSize: resp.data.pageSize, //每页多少条
              total: resp.data.total, //全部有多少条数据
              totalPages: resp.data.totalPages, //全部有几页
            };
            if (this.$refs.page) {
              this.$nextTick(() => {
                if (this.$refs.page) {
                  this.$refs.page.setPages(pages);
                }
              });
            }
          }
        }
      });
    },

    //给组件的回调
    pageCallback(obj) {
      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        this.getList();
      }
      if (obj.code === "comments") {
        this.getList();
      }
      if (obj.code === "storage") {
        this.getList();
      }
      if (obj.code === "batch") {
        //处理批量操作
        console.log(this.choiceListIds, "批量的id");
        if (obj.batch == 1) {
          if (this.choiceListIds.length) {
            //点击删除的处理方法
            this.remove();
          } else {
            Vue.swal("请选择要移除的内容");
            return;
          }
        }
        if (obj.batch == 2) {
          if (this.choiceListIds.length) {
            //点击删除的处理方法
            this.$refs.storage.showModel(this.choiceListIds, "isBatch");
          } else {
            Vue.swal("请选择要移除的内容");
            return;
          }
        }
      }
    },

    //去编辑
    toDetail(item) {
      this.$refs.detail.showModel(item);
    },

    toStorage(item) {
      this.$refs.storage.showModel(item);
    },

    //搜索
    search() {
      this.pageParams.page = 1;
      this.getList();
    },

    //重置搜索参数
    resetParams() {
      this.pageParams.page = 1;
      this.pageParams.keyword = "";
      this.daterange = "";
      this.getList();
    },

    // 列表全选
    checkedAll() {
      if (this.indeterminate) {
        this.choiceListIds = this.allListIds;
      } else {
        this.choiceListIds = [];
      }
    },

    batchHide() {
      Swal.fire({
        title: "确定隐藏?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "隐藏",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          params.ids = this.choiceListIds;
          content.hide(params).then((resp) => {
            if (resp.code == 0) {
              Vue.swal({
                icon: "success",
                title: "隐藏成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              this.getList();
            } else {
              Vue.swal(resp.msg);
            }
          });
        }
      });
    },

    batchShow() {
      Swal.fire({
        title: "确定显示?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "显示",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          params.ids = this.choiceListIds;
          content.show(params).then((resp) => {
            if (resp.code == 0) {
              Vue.swal({
                icon: "success",
                title: "显示成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              this.getList();
            } else {
              Vue.swal(resp.msg);
            }
          });
        }
      });
    },

    batchRevert() {
      Swal.fire({
        title: "确定撤稿?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          params.ids = this.choiceListIds;
          content.revert(params).then((resp) => {
            if (resp.code == 0) {
              Vue.swal({
                icon: "success",
                title: "撤稿成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              this.getList();
            } else {
              Vue.swal(resp.msg);
            }
          });
        }
      });
    },

    remove(item) {
      Swal.fire({
        title: "确定删除?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "删除",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          if (item) {
            params.ids = [];
            params.ids.push(item.id);
          } else {
            params.ids = this.choiceListIds;
          }
          content.remove(params).then((resp) => {
            if (resp.code == 0) {
              Vue.swal({
                icon: "success",
                title: "删除成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              this.getList();
            } else {
              Vue.swal(resp.msg);
            }
          });
        }
      });
    },
  },
};
</script>
